/* eslint-disable prefer-destructuring */
import * as React from "react";

import { Popover as PopoverBase } from "@radix-ui/themes";

import { PortalWrapper } from "../prim.portal-wrapper";

const Root = PopoverBase.Root;

const Trigger = PopoverBase.Trigger;

interface ContentProps extends React.ComponentPropsWithoutRef<typeof PopoverBase.Content> {}
const Content = React.forwardRef<
  React.ElementRef<typeof PopoverBase.Content>,
  ContentProps
>((props, ref) => {
  const { children, ...contentProps } = props;

  return (
    <PopoverBase.Content
      {...contentProps}
      ref={ref}
    >
      <PortalWrapper>
        {children}
      </PortalWrapper>
    </PopoverBase.Content>
  );
});
Content.displayName = PopoverBase.Content.displayName;

const Close = PopoverBase.Close;

export {
  Close,
  Content,
  Root,
  Trigger,
};
